<template>
  <div class="container">
    <div class="login" v-if="init && !user.email">
      <form>
        <label class="form-group margin-bottom">
          <div class="form-group__label">Email</div>
          <div class="form-group__input-button">
            <input
              class="input"
              v-model="email"
              type="email"
              placeholder=""
              autocomplete="username"
            />
          </div>
        </label>
        <label class="form-group margin-bottom">
          <div class="form-group__label">Password</div>
          <div class="form-group__input-button">
            <input
              class="input"
              v-model="password"
              type="password"
              placeholder=""
              autocomplete="current-password"
            />
          </div>
        </label>
        <div class="step__buttons">
          <div v-if="this.errorMessage" class="step__buttons" align="center">
            <p>
              <strong>{{ errorMessage }}</strong>
            </p>
          </div>
          <button class="btn btn--blue-dark" @click.prevent="login">
            Login
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Login",

  data() {
    return {
      email: undefined,
      password: undefined,
      errorMessage: undefined
    };
  },

  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    init() {
      return this.$store.getters["auth/init"];
    }
  },
  methods: {
    async login() {
      try {
        await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password);
        this.$router.push({ name: "Home" });
      } catch (err) {
        this.errorMessage = err;
        console.log(err);
      }
    }
  }
};
</script>
